import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";
import { PageMeta } from "@/components/PageMeta";
import { siteContent } from "@/data/siteContent";

const Paragraphs = ({ items = [], className = "" }) => items.map((item) => <p className={className} key={item}>{item}</p>);
const BulletList = ({ items = [] }) => items.length > 0 ? <ul>{items.map((item) => <li key={item}>{item}</li>)}</ul> : null;

export default function TermsPage() {
  const page = siteContent.termsPage;

  return (
    <div className="site-shell" data-testid="terms-page">
      <PageMeta {...page.meta} />
      <a className="skip-link" href="#main-content" data-testid="skip-to-content-link">Skip to content</a>
      <SiteHeader />
      <main id="main-content">
        <header className="terms-hero" data-testid="terms-hero">
          <div className="site-container terms-reading-width">
            <p className="section-kicker" data-testid="terms-kicker">Legal</p>
            <h1 className="display-title terms-title" data-testid="terms-title">{page.title}</h1>
            <p className="terms-effective-date" data-testid="terms-effective-date">Effective date: {page.effectiveDate}</p>
            <div className="terms-introduction" data-testid="terms-introduction"><Paragraphs items={page.introduction} /></div>
          </div>
        </header>

        <div className="site-container terms-reading-width terms-content" data-testid="terms-content">
          {page.sections.map((section, index) => (
            <section className="terms-section" aria-labelledby={`terms-section-${index + 1}`} key={section.heading} data-testid={`terms-section-${index + 1}`}>
              <h2 id={`terms-section-${index + 1}`}>{section.heading}</h2>
              {section.subheading && <h3>{section.subheading}</h3>}
              <Paragraphs items={section.paragraphs} />
              <BulletList items={section.bullets} />
              {section.secondarySubheading && <h3>{section.secondarySubheading}</h3>}
              <Paragraphs items={section.secondaryParagraphs} />
              <BulletList items={section.secondaryBullets} />
              <Paragraphs items={section.closing} />
              {section.facts && (
                <dl className="terms-facts">
                  {section.facts.map(([label, value]) => (
                    <div key={label}><dt>{label}</dt><dd>{value}</dd></div>
                  ))}
                </dl>
              )}
            </section>
          ))}
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}